import { gsap } from "gsap";
import Draggable from "gsap/Draggable";
import { horizontalLoop } from "../utils/utils";

export default class CarouselGSAP {
	constructor(el) {
		this.element 			= el
		this.init 				= this.init.bind(this)
		this.playVideo 			= this.playVideo.bind(this)
		this.nextSlide 			= this.nextSlide.bind(this)
		this.videos				= [... this.element.querySelectorAll('.video video')]
		this.progressTimeline	= el.querySelector('.block-carousel__progress')
		this.slides 			= gsap.utils.toArray('.block-carousel-gsap__slide')
		this.videoCanvas		= document.getElementById('video-canvas')
		this.activeElement;
		this.currentSlideIndex = 0;
		this.globalTimer;

		// if (typeof(gsap) === "object") {
		// 		console.log('gsap exists!')
		// 	if (typeof(ScrollTrigger) !== "undefined") {
		// 		// ScrollTrigger exists
		// 		console.log('scrolltrigger exists')
		// 	}
		// 	if (typeof(Draggable) !== "undefined") {
		// 		console.log('draggable exists')
		// 	}
		// 	if (typeof(InertiaPlugin) !== "undefined") {
		// 		console.log('inertia exists')
		// 	}
		// }

		this.slides.forEach((box, i) => box.addEventListener("click", () => 
			{
				this.videoCanvas && this.videoCanvas.classList.remove('video__canvas--showing')
				this.loop.toIndex(i, {duration: 0.8, ease: "power1.inOut"})
			}
		));

		if(this.progressTimeline){
			this.timelineAnim = gsap.to(this.progressTimeline, {
				width: '100%',
				duration: 4.5,
				delay: 5,
				paused: true,
				ease: "none",
			})
		}


		this.loop = horizontalLoop(this.slides, {
			paused: true,
			draggable: true, // make it draggable
			snap: true,
			center: true, // active element is the one in the center of the container rather than th left edge
			onChange: (element, index) => { // when the active element changes, this function gets called.

				//this.pauseVideo(this.currentSlideIndex) // PAUSE CURRENT VIDEO
				this.activeElement && this.activeElement.classList.remove("active") // Remove active state
				
				// Start new active state
				element.classList.add("active");
				this.playVideo(index) // Play video on new slide
				this.activeElement = element // Swap index for later
				this.currentSlideIndex = index; // Swap index for finding videos

				// Reset Timer
				if(this.globalTimer){
					clearInterval(this.globalTimer);
				}
				this.globalTimer = setInterval(()=>this.nextSlide(), 4500);
				this.timelineAnim.restart() // Restart timeline animation
			}
		});

		window.onload = (event) => {
			this.element.classList.add('block-carousel-gsap--active')
			this.loop && this.loop.toIndex(1, {duration: 0.8, ease: "power1.inOut"});
		}

	}
  
	init() {

		// console.log(this.slides);

	}

	nextSlide(){
		this.videoCanvas && this.videoCanvas.classList.remove('video__canvas--showing')
		this.loop.next({duration: 0.4, ease:"power1.inOut"});
		this.timelineAnim.restart();
	}

	playVideo(slideIndex)
	{
		this.videos[slideIndex].play()
		this.videoCanvas && this.videoCanvas.classList.add('video__canvas--showing')
	}

	pauseVideo(slideIndex)
	{
		this.videos[slideIndex].pause()
	}

	playTimer()
	{
		this.timelineAnim.restart();
		console.log(this.progressTimeline)
	}

}
